var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createAsyncThunk } from "@reduxjs/toolkit";
import { formatErrorMessage } from "module/common/utils";
import { setUserInfo, setApiKeys, setPlans, setAddOns, setSubscription, setUsageBlockOptions, } from "./reducer";
import { setAuthToken } from "./utils";
import { getApiKeys, getUserInfo, postAuthLogin, postAuthRegister, postAuthVerify, getPlans, getAddOns, getCurrentSubscription, getUsageBlockOptions, patchAccount, patchUser, } from "./api";
export var callPostAuthLogin = createAsyncThunk("callPostAuthLogin", function (request, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var response, authorization, token, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, postAuthLogin({ email: request.email, password: request.password })];
            case 1:
                response = _a.sent();
                authorization = response.headers.authorization;
                token = authorization.replace("Bearer ", "");
                setAuthToken(token);
                thunkApi.dispatch(setUserInfo(response.data));
                return [2 /*return*/, true];
            case 2:
                error_1 = _a.sent();
                return [2 /*return*/, thunkApi.rejectWithValue(formatErrorMessage(error_1))];
            case 3: return [2 /*return*/];
        }
    });
}); });
export var callPostAuthRegister = createAsyncThunk("callPostAuthRegister", function (request, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, postAuthRegister(request)];
            case 1:
                _a.sent();
                return [2 /*return*/, true];
            case 2:
                error_2 = _a.sent();
                return [2 /*return*/, thunkApi.rejectWithValue(formatErrorMessage(error_2))];
            case 3: return [2 /*return*/];
        }
    });
}); });
export var callPostAuthVerify = createAsyncThunk("callPostAuthVerify", function (request, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, postAuthVerify(request)];
            case 1:
                response = _a.sent();
                setAuthToken(request.token);
                thunkApi.dispatch(setUserInfo(response.data));
                return [2 /*return*/, true];
            case 2:
                error_3 = _a.sent();
                return [2 /*return*/, thunkApi.rejectWithValue(formatErrorMessage(error_3))];
            case 3: return [2 /*return*/];
        }
    });
}); });
export var fetchUserInfo = createAsyncThunk("fetchUserInfo", function (_, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getUserInfo()];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
            case 2:
                error_4 = _a.sent();
                return [2 /*return*/, thunkApi.rejectWithValue({ error: formatErrorMessage(error_4) })];
            case 3: return [2 /*return*/];
        }
    });
}); });
export var callGetApiKeys = createAsyncThunk("callGetApiKeys", function (_, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getApiKeys()];
            case 1:
                response = _a.sent();
                thunkApi.dispatch(setApiKeys(response.data));
                return [2 /*return*/, response.data];
            case 2:
                error_5 = _a.sent();
                return [2 /*return*/, thunkApi.rejectWithValue({ error: formatErrorMessage(error_5) })];
            case 3: return [2 /*return*/];
        }
    });
}); });
export var callGetPlans = createAsyncThunk("callGetPlans", function (_, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getPlans()];
            case 1:
                response = _a.sent();
                thunkApi.dispatch(setPlans(response.data));
                return [2 /*return*/, response.data];
            case 2:
                error_6 = _a.sent();
                return [2 /*return*/, thunkApi.rejectWithValue({ error: formatErrorMessage(error_6) })];
            case 3: return [2 /*return*/];
        }
    });
}); });
export var callGetAddOns = createAsyncThunk("callGetAddOns", function (_, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getAddOns()];
            case 1:
                response = _a.sent();
                thunkApi.dispatch(setAddOns(response.data));
                return [2 /*return*/, response.data];
            case 2:
                error_7 = _a.sent();
                return [2 /*return*/, thunkApi.rejectWithValue({ error: formatErrorMessage(error_7) })];
            case 3: return [2 /*return*/];
        }
    });
}); });
export var callGetCurrentSubscription = createAsyncThunk("callGetCurrentSubscription", function (_, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getCurrentSubscription()];
            case 1:
                response = _a.sent();
                thunkApi.dispatch(setSubscription(response.data ? response.data : null));
                return [2 /*return*/, response.data];
            case 2:
                error_8 = _a.sent();
                return [2 /*return*/, thunkApi.rejectWithValue({ error: formatErrorMessage(error_8) })];
            case 3: return [2 /*return*/];
        }
    });
}); });
export var callGetUsageBlockOptions = createAsyncThunk("callGetUsageBlockOptions", function (_, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getUsageBlockOptions()];
            case 1:
                response = _a.sent();
                thunkApi.dispatch(setUsageBlockOptions(response.data));
                return [2 /*return*/, response.data];
            case 2:
                error_9 = _a.sent();
                return [2 /*return*/, thunkApi.rejectWithValue({ error: formatErrorMessage(error_9) })];
            case 3: return [2 /*return*/];
        }
    });
}); });
export var callPatchAccount = createAsyncThunk("callPatchAccount", function (payload, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, patchAccount(payload)];
            case 1:
                response = _a.sent();
                thunkApi.dispatch(setUserInfo(response.data));
                return [2 /*return*/, response.data];
            case 2:
                error_10 = _a.sent();
                return [2 /*return*/, thunkApi.rejectWithValue({ error: formatErrorMessage(error_10) })];
            case 3: return [2 /*return*/];
        }
    });
}); });
export var callPatchUser = createAsyncThunk("callPatchUser", function (payload, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, patchUser(payload)];
            case 1:
                response = _a.sent();
                thunkApi.dispatch(setUserInfo(response.data));
                return [2 /*return*/, response.data];
            case 2:
                error_11 = _a.sent();
                return [2 /*return*/, thunkApi.rejectWithValue({ error: formatErrorMessage(error_11) })];
            case 3: return [2 /*return*/];
        }
    });
}); });
